/**
 * Rapor alanlarının sihirbazda ad altında gösterilen kısa açıklamaları.
 *
 * Katalog (`icraproweb.rapor_alanlari`) açıklama kolonu taşımıyor ve katalog
 * verisine kolon eklemek veri kararıdır; bu yüzden açıklama istemcide tutulur.
 * Listede **yalnız adı kendi başına anlaşılmayan alanlar** var — "Alacaklı Adı
 * Ve Soyadı" gibi kendini anlatan alanlara açıklama yazmak gürültü olur.
 *
 * Haritada olmayan alan açıklamasız gösterilir (tek satır kalır).
 */
const ACIKLAMALAR: { [kod: string]: string } = {
  // Dosya bilgileri
  kart_no: "İcrapro içindeki dosya kart numarası",
  takip_dosya_esas_no: "İcra dairesindeki dosya esas numarası (ör. 2024/1042)",
  kurum_dosya_no: "Alacaklı kurumun kendi dosya numarası",
  mts_esas_no: "Merkezi Takip Sistemi esas numarası",
  aktar_takip_kart_no: "Aktarımla gelen eski kart numarası",
  tuketici_kodu: "Alacaklı kurumun müşteri / abone kodu",
  takip_mahiyeti: "Takibin dayandığı belge türü",
  takip_yolu_isim: "Haciz veya iflas yolu",
  takip_durumu: "Dosyanın hukuki durumu (açık, kapalı…)",
  dosya_sorumlusu: "Dosyayı takip eden departman veya avukat",
  icra_dairesi: "Takibin açıldığı yetkili icra dairesi",

  // Taraflar
  taraf_turu: "Kaydın alacaklı mı borçlu mu tarafına ait olduğu",
  borclu_iletisim_bilgileri: "Telefon, e-posta gibi kayıtlı iletişim bilgileri",
  alacakli_iletisim_bilgileri: "Telefon, e-posta gibi kayıtlı iletişim bilgileri",

  // Finansal
  takip_toplami: "Faiz ve harçlar dahil takibe çıkış tutarı",
  genel_toplam: "Takip toplamı ve sonradan işleyen kalemlerin toplamı",
  kalan_tutar: "Açık kalan toplam borç bakiyesi",
  asil_alacak: "Faiz ve masraf hariç ana alacak",
  asil_alacak_para_birimi: "Asıl alacağın kaydedildiği para birimi",
  harca_esas_deger: "Harç hesabında esas alınan tutar",
  cek_tazminati: "Kambiyo takibinde talep edilen çek tazminatı",
  cezai_sart: "Sözleşmeden doğan cezai şart tutarı",
  ihtar_masrafi: "Takip öncesi ihtarname masrafı",
  protesto: "Protesto masrafı",
  komisyon: "Talep edilen komisyon tutarı",
  vekalet_ucreti: "Hesaplanan nispi vekalet ücreti",
  ihtiyati_haciz_masrafi: "İhtiyati haciz aşamasında yapılan masraf",
  ihtiyati_haciz_vekalet_ucreti: "İhtiyati haciz için hesaplanan vekalet ücreti",

  // Harçlar
  harc_turu_toplam_tutar: "Tüm harç türlerinin toplamı",
  tahsil_harci: "Tahsilat üzerinden alınan harç",
  tahsil_harci_orani: "Uygulanan tahsil harcı yüzdesi",
  cezaevi_harci: "Tahsilat üzerinden alınan cezaevi harcı",
  basvuru_harci: "Takip açılışında ödenen başvuru harcı",
  pesin_harc: "Takip açılışında ödenen peşin harç",
  basvuru_pesin_harc: "Başvuru ve peşin harcın toplamı",
  vekalet_harci: "Vekaletname harcı",
  vekalet_basvuru_pesin_harc: "Vekalet, başvuru ve peşin harcın toplamı",

  // Faiz
  takip_oncesi_faiz: "Takip tarihine kadar işleyen faiz",
  takip_sonrasi_faiz: "Takip tarihinden sonra işleyen faiz",
  faiz_orani_yuzde: "Uygulanan faiz oranı",
  faiz_periyodu: "Faizin aylık mı yıllık mı işlediği",
  takip_oncesi_bsmv: "Takip öncesi banka ve sigorta muameleleri vergisi",
  takip_sonrasi_bsmv: "Takip sonrası banka ve sigorta muameleleri vergisi",

  // Tahsilat
  tahsilat_tutari: "Tek bir tahsilat kaydının kesinti öncesi tutarı",
  tahsilat_toplami: "Kesintiler düşüldükten sonraki net tahsilat toplamı",
  tahsilat_toplami_brut: "Kesinti öncesi toplam tahsilat",
  takip_oncesi_tahsilat_toplami: "Takip tarihinden önce yapılan tahsilatlar",
  takip_sonrasi_tahsilat_toplami: "Takip tarihinden sonra yapılan tahsilatlar",
  tahsil_edilen_borclu_kisi: "Tahsilatın yapıldığı gerçek kişi borçlu",
  tahsil_edilen_borclu_kurum: "Tahsilatın yapıldığı tüzel kişi borçlu",
  icra_dairesi_odenen: "İcra dairesine yapılan ödeme tutarı",
  avukata_odenen: "Avukata yapılan ödeme tutarı",
  vekalet_ucret_belge_no: "Vekalet ücreti için düzenlenen belge numarası",
  son_tahsilat_tarihi: "Dosyadaki en son tahsilatın tarihi",

  // Masraf
  masraf_toplami: "Dosyaya işlenen tüm masrafların toplamı",
  masraf2_toplami_resmi: "Belgeli (resmi) masrafların toplamı",
  masraf2_toplami_gr: "Belgesiz (gider/rapor) masrafların toplamı",
  son_masraf_tarihi: "Dosyadaki en son masrafın tarihi",
  alacak_kalemi_aciklama: "Alacak kalemine yazılan serbest açıklama",

  // Tebligat
  barkod_no: "Tebligatın PTT barkod numarası",
  tebligat_sekli: "Tebligatın gönderim biçimi",
  tebligat_durumu: "Ödeme veya icra emrinin tebliğ durumu",

  // Notlar
  not_turu: "Notun sınıflandırıldığı tür",
  not_giris_tarihi: "Notun sisteme girildiği tarih",

  // Haciz ve mal varlığı
  haciz_turu: "Uygulanan haciz tedbirinin türü",
  haciz_tarihi: "Haczin uygulandığı tarih",
  talep_tarihi: "Haciz talebinin yapıldığı tarih",
  isveren_adi: "Maaş haczi için işveren bilgisi",
  isveren_adres: "Maaş haczi için işveren adresi",
  muzakere_adres: "Görüşme / müzakere için kayıtlı adres",
  hisse_kar_payi_turu: "Haczedilen hisse veya kar payının türü",
  hisse_kar_payi_mersis_no: "İlgili şirketin MERSİS numarası",
  hisse_kar_payi_sirket_adi: "Hissenin ait olduğu şirket",
  tasinirlar_merhunun_ne_oldugu: "Rehinli taşınırın tanımı",
  tasinmazlar_merhunun_ne_oldugu: "Rehinli taşınmazın tanımı",
  arac_ozellikleri: "Araca ait serbest metin özellikler",
};

export function raporAlanAciklamasi(kod: string): string {
  return ACIKLAMALAR[kod] || "";
}

export default ACIKLAMALAR;
